import React from "react";
import { Box, Typography, Container, Divider, Paper } from "@mui/material";

// Import your images
import christmasBanner1 from "../../Images/Neotel_POS_06-01.jpg";
import christmasBanner2 from "../../Images/Neotel_POS_06-03.jpg";
import christmasBanner3 from "../../Images/Neotel_POS_06-02.jpg";

export default function ChristmasEvent() {
  return (
    <Box sx={{ backgroundColor: "#fff", mt: { lg: 15, sm: 15, xs: 10 }, color: "#333" }}>
      {/* Banner 1 */}
      <Box
        component="img"
        src={christmasBanner1}
        alt="Christmas Banner 1"
        sx={{
          width: "100%",
          height: "auto", // ✅ This keeps full image visible (no cropping)
          display: "block",
        }}
      />

      {/* Section 1 */}
      <Container maxWidth="md" sx={{ py: 5 }}>
        <Typography
          variant="h4"
          align="center"
          sx={{
            color: "#B71C1C",
            fontWeight: "bold",
            mb: 3,
          }}
        >
          Welcome to the Neotel Christmas Celebration 2025 – Top Up & Win Contest!
        </Typography>

        <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8 }}>
          This festive season, recharge your Neotel number or activate your favorite
          bundle and stand a chance to win exciting weekly prizes and grand festive
          rewards.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8 }}>
          The more you top up or buy bundles, the greater your chances to win — it’s that
          simple!
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8 }}>
          Spread the joy, stay connected, and celebrate Christmas the Neotel way.
        </Typography>
      </Container>

      {/* Banner 2 */}
      <Box
        component="img"
        src={christmasBanner2}
        alt="Christmas Banner 2"
        sx={{
          width: "100%",
          height: "auto",
          display: "block",
        }}
      />

      {/* Section 2 */}
      <Container maxWidth="md" sx={{ py: 5 }}>
        <Typography
          variant="h5"
          align="center"
          sx={{ color: "#B71C1C", fontWeight: "bold", mb: 3 }}
        >
          Let the celebrations begin with Neotel!
        </Typography>

        <Paper elevation={2} sx={{ p: 3, backgroundColor: "#fff8e1" }}>
          <Typography variant="h6" sx={{ color: "#4E342E", fontWeight: "bold", mb: 2 }}>
            Promo Duration
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            <strong>Start Date:</strong> 15 October 2025
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            <strong>End Date:</strong> 24 December 2025
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            <strong>Grand Draw Date:</strong> 24 December 2025
          </Typography>
          <Typography variant="body1">
            <strong>Grand Prize Announcement:</strong> 24 December 2025
          </Typography>
        </Paper>

        <Divider sx={{ my: 4 }} />

        <Typography
          variant="h6"
          sx={{ color: "#4E342E", fontWeight: "bold", mb: 2 }}
        >
          Customer Participation
        </Typography>

        <Typography variant="body1" sx={{ mb: 2 }}>
          <strong>Q:</strong> Who can participate?
          <br />
          <strong>A:</strong> All Neotel Nauru PREPAID customers are automatically
          registered for the contest.
        </Typography>

        <Typography variant="body1" sx={{ mb: 2 }}>
          <strong>Q:</strong> How do customers earn points?
          <br />
          <strong>A:</strong> Points are earned with each Bundle activation or Top-Up
          between 15th October 2025 and 23rd December 2025.
        </Typography>

        <Typography variant="body1" sx={{ mb: 2 }}>
          <strong>Q:</strong> How are winners selected?
          <br />
          <strong>A:</strong> Weekly winners are based on highest points. Ties are
          resolved via lucky draw.
        </Typography>

        <Typography variant="body1">
          <strong>Q:</strong> When are weekly draws held?
          <br />
          <strong>A:</strong> Every Wednesday from 22 October to 24 December 2025.
        </Typography>
      </Container>

      {/* Banner 3 */}
      <Box
        component="img"
        src={christmasBanner3}
        alt="Christmas Banner 3"
        sx={{
          width: "100%",
          height: "auto",
          display: "block",
        }}
      />

      {/* Section 3 */}
      <Container maxWidth="md" sx={{ py: 5 }}>
        <Typography
          variant="h5"
          align="center"
          sx={{ color: "#B71C1C", fontWeight: "bold", mb: 3 }}
        >
          Bundle Categories & Points
        </Typography>

        <Paper sx={{ p: 3, mb: 4, backgroundColor: "#f1f8e9" }}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            <strong>Category 1 – Lower:</strong> Egow ($4, Daily) or $1–$19 Top-Up → 1 Point
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            <strong>Category 2 – Mid-Level:</strong> Itsibab ($20), Eokwoe ($30), Eapwe
            ($45) or $20–$88 Top-Up → 5 Points
          </Typography>
          <Typography variant="body1">
            <strong>Category 3 – Premium:</strong> Eae ($35), Iyibur ($89), Neo 5G Router
            ($150) or $89+ Top-Up → 20 Points
          </Typography>
        </Paper>

        <Typography
          variant="h5"
          align="center"
          sx={{ color: "#B71C1C", fontWeight: "bold", mb: 2 }}
        >
          Rewards
        </Typography>

        <Paper sx={{ p: 3, mb: 4, backgroundColor: "#fff3e0" }}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            <strong>Weekly Prizes:</strong> Bluetooth Speakers, Headphones, Earbuds,
            Waterproof Speakers, Smart LED Bluetooth Speakers
          </Typography>
          <Typography variant="body1">
            <strong>Grand Prizes (24 Dec 2025):</strong> Electric Bicycle (1 Winner),
            65-inch Smart TV (1 Winner), Refrigerator (2 Winners)
          </Typography>
        </Paper>

        <Typography
          variant="h5"
          align="center"
          sx={{ color: "#B71C1C", fontWeight: "bold", mb: 2 }}
        >
          Common Questions
        </Typography>

        <Typography variant="body1" sx={{ mb: 2 }}>
          <strong>Q:</strong> Do I need to register? <br /> <strong>A:</strong> No
          registration needed – points are auto-tracked.
        </Typography>

        <Typography variant="body1" sx={{ mb: 2 }}>
          <strong>Q:</strong> How can I check my points earned? <br />{" "}
          <strong>A:</strong> Download My Neotel App from PlayStore, Text “RP” to 121, or
          visit www.neotel.nr/selfcare.
        </Typography>

        <Typography variant="body1" sx={{ mb: 2 }}>
          <strong>Q:</strong> Where are winners announced? <br />{" "}
          <strong>A:</strong> On Neotel’s social media platforms.
        </Typography>

        <Typography variant="body1" sx={{ mb: 2 }}>
          <strong>Q:</strong> Where can winners collect prizes? <br />{" "}
          <strong>A:</strong> Neotel Brand Store at Civic Centre.
        </Typography>

        <Typography variant="body1" sx={{ mb: 2 }}>
          <strong>Q:</strong> Can staff participate? <br /> <strong>A:</strong> No, Neotel
          staff are ineligible.
        </Typography>

        <Divider sx={{ my: 4 }} />

        <Typography
          variant="h5"
          align="center"
          sx={{ color: "#B71C1C", fontWeight: "bold", mb: 2 }}
        >
          Terms & Conditions Summary
        </Typography>

        <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
          • Top Ups & bundle activations are eligible. <br />
          • Physical goods purchases do not count. <br />
          • No refunds. <br />
          • Prizes are non-transferable and not redeemable for cash. <br />
          • Neotel staff are ineligible. <br />
          • Neotel reserves the right to amend or cancel the promo.
        </Typography>
      </Container>
    </Box>
  );
}
